<template>
    <div class="width100" :id="domID">
        <div class="clear"></div>
        <div class="shadow width100 marginbottom15">
            <div class="padding20 lineheight22 marginbottom15">
                <div class="width100">
                    <p
                        v-if="subtitle"
                        class="font12 bold midblauw marginbottom10"
                    >
                        {{ subtitle }}
                    </p>
                    <span
                        :class="{
                            [aliasImage]: true,
                            floatright: true,
                            margin10imp: true,
                        }"
                    ></span>
                    <p v-if="introText">
                        {{ introText }}
                    </p>

                    <USPSItems
                        v-if="uspsPreview"
                        :items="uspsItems"
                    ></USPSItems>

                    <br />
                    <a
                        v-if="moreText"
                        v-on:click="toggleViewMore()"
                        id="inline"
                        class="fancybox readmore"
                    >
                        <span v-if="!viewMore">
                            <b> <font-awesome-icon icon="plus" /> Lees meer </b>
                        </span>
                        <span v-else="">
                            <font-awesome-icon icon="minus" />
                            Verbergen
                        </span>
                        <br />
                        <br />
                    </a>

                    <transition name="fade" appear>
                        <div v-if="viewMore">
                            <div
                                id="rederij_omschrijving"
                                style="height: auto;"
                            >
                                <p v-html="moreText"></p>
                                <USPSItems
                                    v-if="!uspsPreview"
                                    :items="uspsItems"
                                ></USPSItems>
                            </div>
                            <div v-if="href">
                                <b>
                                    <a :href="href">{{ linkText }}</a>
                                </b>
                                (Let op: je gaat naar een andere pagina)
                                <br />
                                <br />
                            </div>
                        </div>
                    </transition>
                </div>

                <div class="clear floatleft"></div>
            </div>
        </div>
        <div class="clear height10"></div>
    </div>
</template>

<script>
import USPSItems from './USPSItems.vue'

export default {
    name: 'readMoreContainer',
    components: {
        USPSItems,
    },
    data: function() {
        return { viewMore: false }
    },
    methods: {
        toggleViewMore: function() {
            this.viewMore = !this.viewMore
        },
    },
    props: {
        subtitle: String,
        introText: String,
        moreText: String,
        uspsItems: Array,
        aliasImage: String,
        domID: String,
        uspsPreview: Boolean,
        href: String,
        linkText: String,
    },
}
</script>

<style scoped>
.readmore {
    float: right;
}
</style>
